import widgetsDataService from '../services/widgetsDataService.js'

const exchangesRating = {
    async updateDynamicsData() {
        let widgets = $('.widget-exchange-rating[data-exchange-ids]');

        for (let i = 0; i < widgets.length; i++) {
            let data = $(widgets[i]).data();
            let exchangeIdsArray = data.exchangeIds.replace(/\s+/g, '').split(',');

            let widgetData = await widgetsDataService.fetchWidgetDataAsync('getExchangesRatingData', data.exchangeIds);

            exchangeIdsArray.forEach(exchangeId => {
                widgetsDataService.updateDataOnPage(`.widget-exchange-info[data-field="${exchangeId}"]`, widgetData[exchangeId]);
            })
        }
    }
}

export default exchangesRating;